import {
  WSButton,
  WSCard,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/wingspan-api-sdk";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { addNotification } from "../../../components/Notification/Notification";
import { analyticsService } from "@services/analyticsService";
import { useModalRequestTaxDocument } from "../modals/ModalRequestTaxDocument";

type Props = {
  year: number;
  savings: number;
  loading?: boolean;
};

export const CardTaxReadyDocuments: React.FC<Props> = props => {
  const modalRequest = useModalRequestTaxDocument();

  const request = async (documentName: string, event: string) => {
    const confirmed = await modalRequest.open({
      documentName,
      year: props.year
    });
    if (confirmed) {
      analyticsService.track(`${event} Requested`, { year: props.year });
      addNotification({ text: `${props.year} ${documentName} requested` });
    }
  };

  return (
    <WSCard header={{ label: "Tax-ready documents" }}>
      <WSList gap="M">
        <WSText.ParagraphSm color="gray600">
          You're projected to save{" "}
          <WSText.ParagraphSm inline weight="medium" shimmer={props.loading}>
            {formatMoney(props.savings, Currency.USD)}
          </WSText.ParagraphSm>{" "}
          on your tax payments with the deductions we found. Use the documents
          below to file your annual taxes, or send to your accountant.
        </WSText.ParagraphSm>
        <WSButton.Link
          icon="download"
          onClick={() => request("Schedule C PDF", "Schedule-C")}
        >
          {props.year} Schedule C PDF
        </WSButton.Link>
        <WSButton.Link
          icon="download"
          onClick={() => request("Tax Summary Sheet", "Tax Summary Sheet")}
        >
          {props.year} Tax Summary Sheet
        </WSButton.Link>
      </WSList>
    </WSCard>
  );
};
